/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Compare_DescriptionInputs */

const en_gc_resources_compare_description = /** @type {(inputs: Gc_Resources_Compare_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft is a free, open-source Excel alternative for exploring local spreadsheet work. Microsoft Excel offers a mature ecosystem, desktop VBA and established collaboration through Microsoft 365. Choose around the files and workflows you actually use, especially if colleagues depend on a shared workbook.`)
};

const zh_gc_resources_compare_description = /** @type {(inputs: Gc_Resources_Compare_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft 是免费开源的 Excel 替代选择，适合探索本地电子表格工作。Microsoft Excel 拥有成熟生态、桌面 VBA 和 Microsoft 365 协作。请根据真实文件与工作流程选择，尤其是多人依赖的共享工作簿。`)
};

/**
* | output |
* | --- |
* | "GridCraft is a free, open-source Excel alternative for exploring local spreadsheet work. Microsoft Excel offers a mature ecosystem, desktop VBA and establish..." |
*
* @param {Gc_Resources_Compare_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_compare_description = /** @type {((inputs?: Gc_Resources_Compare_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Compare_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_compare_description(inputs)
	return zh_gc_resources_compare_description(inputs)
});
export { gc_resources_compare_description as "gc.resources.compare.description" }